<template>
  <div class="countdown-timer">
    <div class="time-block">
      <span class="time">{{ hours }}</span>
      <span class="label">Horas</span>
    </div>
    <div class="separator">:</div>
    <div class="time-block">
      <span class="time">{{ minutes }}</span>
      <span class="label">Minutos</span>
    </div>
    <div class="separator">:</div>
    <div class="time-block">
      <span class="time">{{ seconds }}</span>
      <span class="label">Segundos</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    targetDate: {
      type: [String, Date],
      required: true,
    },
  },
  data() {
    return {
      now: new Date(),
      interval: null,
    };
  },
  computed: {
    target() {
      return new Date(this.targetDate);
    },
    remaining() {
      const remaining = this.target.getTime() - this.now.getTime();
      return Math.max(0, remaining);
    },
    hours() {
      return String(Math.floor(this.remaining / (1000 * 60 * 60))).padStart(2, '0');
    },
    minutes() {
      return String(Math.floor((this.remaining / (1000 * 60)) % 60)).padStart(2, '0');
    },
    seconds() {
      return String(Math.floor((this.remaining / 1000) % 60)).padStart(2, '0');
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.now = new Date();
      if (this.remaining === 0) {
        clearInterval(this.interval);
        this.$emit('finished');
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.countdown-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 0px 0;
}
.time-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
}
.time {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
}
.label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #666;
}
.separator {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  padding: 0 5px;
  align-self: flex-start;
  margin-top: -3px;
}
</style>
